import { Customer } from "./customer.model";
import { MetalsOrder } from "./metals-order.model";
import { MetalsProductVersion } from "./metals-product-version.model";

export enum MetalsOrderedProductStatus {
	Draft = 'Draft',
	Released = 'Released',
	Hold = 'Hold',
	Complete = 'Complete',
	Canceled = 'Canceled',
	ToBeCanceled = 'ToBeCanceled',
	Blanket = 'Blanket',
}

export enum MetalsOrderedProductType {
	Prototype = 'Prototype',
	Default = 'Default'
}

export interface MetalsOrderedProduct_Base {
	id: string;
	metalsOrderId: string;
	quantity: number;
	customerId: string;
	dueDate: Date;
	salesOrderNumber: string
	note: string;
	productionNote: string;
	translatedProductionNote: string;
	status: MetalsOrderedProductStatus;
	createdById: string;
	createdOn: Date;
	updatedById: string;
	updatedOn: Date;
	changeLog: MetalsOrderedProductChangeLog[];
	productionPlanComplete: boolean;
}

export interface MetalsOrderedProduct_Default extends MetalsOrderedProduct_Base {
	productId: string;
	type: MetalsOrderedProductType.Default
}

export interface MetalsOrderedProduct_Prototype extends MetalsOrderedProduct_Base {
	type: MetalsOrderedProductType.Prototype;
	partNumber: string;
	description: string;
}

export type MetalsOrderedProduct = MetalsOrderedProduct_Default | MetalsOrderedProduct_Prototype;

export interface DisplayMetalsOrderedProduct_Base {
	orderCustomer: Customer;
	orderedProduct: MetalsOrderedProduct;
	order: MetalsOrder;
}
export interface DisplayMetalsOrderedProduct_Default extends DisplayMetalsOrderedProduct_Base {
	productCustomer: Customer;
	orderedProduct: MetalsOrderedProduct_Default;
	orderedProductVersion: MetalsProductVersion;
	type: MetalsOrderedProductType.Default
}

export interface DisplayMetalsOrderedProduct_Prototype extends DisplayMetalsOrderedProduct_Base {
	orderedProduct: MetalsOrderedProduct_Prototype;
	type: MetalsOrderedProductType.Prototype
}

export type DisplayMetalsOrderedProduct = DisplayMetalsOrderedProduct_Default | DisplayMetalsOrderedProduct_Prototype

export interface MetalsOrderedProductChangeLog {
	id: string;
	createdOn: Date;
	createdById: string;
	text: string;
}

export function toDisplayMetalsOrderedProducts(
	orderedProducts: MetalsOrderedProduct[],
	customerDict: Record<string, Customer>,
	productIdToProductVersionDict: Record<string, MetalsProductVersion>,
	orderDict: Record<string, MetalsOrder>,
) {
	const displayOrdredProducts: DisplayMetalsOrderedProduct[] = orderedProducts.map(orderedProduct => {
		orderedProduct.changeLog.sort((a, b) => b.createdOn.getTime() - a.createdOn.getTime())
		const baseDisplay: DisplayMetalsOrderedProduct_Base = {
			orderCustomer: customerDict[orderedProduct.customerId],
			orderedProduct,
			order: orderDict[orderedProduct.metalsOrderId]
		}

		let display: DisplayMetalsOrderedProduct;

		if (orderedProduct.type === MetalsOrderedProductType.Default) {
			const orderedProductVersion = productIdToProductVersionDict[orderedProduct.productId];

			display = {
				...baseDisplay,
				type: MetalsOrderedProductType.Default,
				orderedProductVersion,
				productCustomer: customerDict[orderedProductVersion.customerId],
				orderedProduct,
			}
		} else {

			display = {
				...baseDisplay,
				type: MetalsOrderedProductType.Prototype,
				orderedProduct,
			}
		}

		return display;
	})

	return displayOrdredProducts
}
